// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.coupon-scroll-wrapper {
    display: flex;
    flex-direction: row;
    overflow: scroll;
    flex-wrap: nowrap;
    max-width: calc(100% - 32px);
}

.coupon-scroll-wrapper::-webkit-scrollbar {
    display: none;
}
`, "",{"version":3,"sources":["webpack://./../client/page/detail/views/content/components/CouponEntryLineV2/index.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".coupon-scroll-wrapper {\n    display: flex;\n    flex-direction: row;\n    overflow: scroll;\n    flex-wrap: nowrap;\n    max-width: calc(100% - 32px);\n}\n\n.coupon-scroll-wrapper::-webkit-scrollbar {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
